

import { Clock, MapPin, User } from "lucide-react";

interface SessionMetadataProps {
  formattedDate: string;
  formattedDuration: string;
  professor?: string;
  location?: string;
}

export function SessionMetadata({
  formattedDate,
  formattedDuration,
  professor,
  location,
}: SessionMetadataProps) {
  return (
    <div>
      <div className="text-sm text-muted-foreground">{formattedDate}</div>
      <div className="flex flex-wrap gap-y-2 gap-x-4 mt-1">
        <div className="flex items-center gap-1 text-sm text-muted-foreground">
          <Clock className="h-4 w-4" />
          <span>{formattedDuration}</span>
        </div>
        {professor && (
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <User className="h-4 w-4" />
            <span>{professor}</span>
          </div>
        )}
        {location && (
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <MapPin className="h-4 w-4" />
            <span>{location}</span>
          </div>
        )}
      </div>
    </div>
  );
}
